import styled from "styled-components";

const Title = styled.legend`
  color: ${props => props.theme.header.title};
  font-size: 2rem;
  white-space: nowrap;
  font-weight: 400;
`;

export default Title;